import * as React from 'react'

import { TNoColorSvgProps, TSvgProps } from '../Svg'

type TProps = NoChildren &
  TNoColorSvgProps & {
    /**
     * the color of the logo, *CSS `fill` of the `path` element*
     */
    fill?: TSvgProps['fill']
  }

/**
 * SVG speedlo logo with configurable attributes
 * mostly to be used in combination with `Svg` helper component
 */
export const SpeedloLogo: React.FC<TProps> = ({ fill, height = `100%`, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112.59 28.76" height={height} {...props}>
      <path
        d="M59.19 22.94a9 9 0 01-7.66-3.81l3.46-2a5.29 5.29 0 004.2 1.87c.9 0 3.94-.3 4.48-3H38.2c.53 2.69 3.58 3 4.47 3a5.32 5.32 0 004.21-1.91l3.46 2a9 9 0 01-7.67 3.81c-3.19 0-8.92-1.82-8.92-8.56s5.85-8.53 8.92-8.53a8.32 8.32 0 018.26 6 8.33 8.33 0 018.26-6c3.08 0 8.92 1.79 8.92 8.53s-5.72 8.56-8.92 8.56zm-51.49 0c4.29 0 6.74-1.94 6.74-5.34 0-4.23-3.76-4.71-6.53-5.19-.72-.09-3.11-.35-3.11-1.41 0-.8 1.29-1.22 2.15-1.22a9.3 9.3 0 014.65 1.52l2.33-3A10.74 10.74 0 007.1 5.85C5.52 5.85.33 6.24.33 11c0 4.12 4.26 4.77 6.5 5.16.87.15 3.16.27 3.16 1.37C10 18.41 9 19 7.64 19a10.26 10.26 0 01-5.31-1.76L0 20.38a11.76 11.76 0 007.7 2.56zm95.94-13.18a4.49 4.49 0 014.51 4.62 4.53 4.53 0 01-4.51 4.69 4.47 4.47 0 01-4.5-4.69 4.53 4.53 0 014.5-4.62zm0 13.18a8.77 8.77 0 009-8.56 8.93 8.93 0 00-17.84 0 8.73 8.73 0 008.89 8.56zM89 22.56h4.41V0L89 2.39v20.17zm-69.53-8.15c0-2.86 1.73-4.62 4.5-4.62a4.39 4.39 0 014.51 4.62A4.32 4.32 0 0124 19.07a4.33 4.33 0 01-4.5-4.66zm.18-8.2h-4.42v22.55l4.42-2.39v-5.45a6.19 6.19 0 005 2c5.19 0 8.23-3.84 8.23-8.56s-3-8.56-8.23-8.56a6.61 6.61 0 00-5 2V6.21zm62.86 8.14c0 2.87-1.73 4.65-4.51 4.65a4.39 4.39 0 01-4.5-4.63 4.51 4.51 0 119 0zm-.18 8.21h4.41V0l-4.41 2.39v5.46a6.23 6.23 0 00-5-2.06c-5.19 0-8.24 3.85-8.24 8.56s3 8.56 8.24 8.56a6.68 6.68 0 005-2v1.64zM42.64 9.76a3.81 3.81 0 013.88 3.13h-8.2c.18-1.67 1.76-3.13 4.32-3.13zm16.58 0a3.82 3.82 0 00-3.88 3.13h8.21c-.18-1.67-1.76-3.13-4.33-3.13z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  )
}
